import { render, staticRenderFns } from "./PagingListTable.vue?vue&type=template&id=bea22654&scoped=true&lang=pug"
import script from "./PagingListTable.vue?vue&type=script&lang=js"
export * from "./PagingListTable.vue?vue&type=script&lang=js"
import style0 from "./PagingListTable.vue?vue&type=style&index=0&id=bea22654&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bea22654",
  null
  
)

export default component.exports